<!-- TABLE -->
<div style="overflow: scroll">
  <mat-table
    [dataSource]="data"
    matSort
    matSortActive="patientName"
    matSortDirection="asc"
    matSortDisableClear
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="columnDropped($event)"
  >
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox #masterCheckbox class="ml-15" (change)="$event ? masterToggle() : null"> </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox
          class="ml-15"
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="lastname">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "model.patient.name" | translate }}
        <app-item-filter
          fieldName="{{ 'model.patient.name' | translate }}"
          [translateFieldKey]="'model.patient.name'"
          propertyName="lastname"
          [dataType]="dataType.TEXT"
          [defaultValue]="activeFilters | filterFor : 'lastname'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="redirectToPatientPage(row.caremateIdentifier)" style="cursor: pointer">{{
        row.lastname
      }}</mat-cell>
    </ng-container>

    <!-- Firstname Column -->
    <ng-container matColumnDef="firstname">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "model.patient.firstname" | translate }}
        <app-item-filter
          fieldName="{{ 'model.patient.firstname' | translate }}"
          [translateFieldKey]="'model.patient.firstname'"
          propertyName="firstname"
          [dataType]="dataType.TEXT"
          [defaultValue]="activeFilters | filterFor : 'firstname'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="redirectToPatientPage(row.caremateIdentifier)" style="cursor: pointer">{{
        row.firstname
      }}</mat-cell>
    </ng-container>

    <!-- SSIN Column -->
    <ng-container matColumnDef="ssin">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "forms.SSIN" | translate }}
        <app-item-filter
          fieldName="{{ 'forms.SSIN' | translate }}"
          [translateFieldKey]="'forms.SSIN'"
          propertyName="ssin"
          [dataType]="dataType.TEXT"
          [defaultValue]="activeFilters | filterFor : 'ssin'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.ssin }}</mat-cell>
    </ng-container>

    <!-- Birth Date -->
    <ng-container matColumnDef="birthDate">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "table.birthdate" | translate }}
        <app-item-filter
          fieldName="{{ 'table.birthdate' | translate }}"
          [translateFieldKey]="'table.birthdate'"
          propertyName="birthDate"
          [dataType]="dataType.DATE"
          [defaultValue]="activeFilters | filterFor : 'birthDate'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.birthDate | safeDate }}</mat-cell>
    </ng-container>

    <!-- Category -->
    <ng-container matColumnDef="category">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "table.category" | translate }}
        <app-item-filter
          fieldName="{{ 'table.category' | translate }}"
          [translateFieldKey]="'table.category'"
          propertyName="category"
          [dataType]="dataType.TEXT"
          [defaultValue]="activeFilters | filterFor : 'category'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ "forms.prescription.type." + row.prescription.category | translate }}</mat-cell>
    </ng-container>

    <!-- Start Date -->
    <ng-container matColumnDef="startDate">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "table.periodStart" | translate }}
        <app-item-filter
          fieldName="{{ 'table.periodStart' | translate }}"
          [translateFieldKey]="'table.periodStart'"
          propertyName="startDate"
          [dataType]="dataType.DATE"
          [defaultValue]="activeFilters | filterFor : 'startDate'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.startDate | safeDate }}</mat-cell>
    </ng-container>

    <!-- End Date -->
    <ng-container matColumnDef="endDate">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "table.periodEnd" | translate }}
        <app-item-filter
          fieldName="{{ 'table.periodEnd' | translate }}"
          [translateFieldKey]="'table.periodEnd'"
          propertyName="endDate"
          [dataType]="dataType.DATE"
          [defaultValue]="activeFilters | filterFor : 'endDate'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.endDate | safeDate }}</mat-cell>
    </ng-container>

    <!-- Code -->
    <ng-container matColumnDef="code">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "table.code" | translate }}
        <app-item-filter
          fieldName="{{ 'table.code' | translate }}"
          [translateFieldKey]="'table.code'"
          propertyName="code"
          [dataType]="dataType.TEXT"
          [defaultValue]="activeFilters | filterFor : 'code'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.code }}</mat-cell>
    </ng-container>

    <!-- Amount -->
    <ng-container matColumnDef="totalPrice">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "table.amount" | translate }}
        <app-item-filter
          fieldName="{{ 'table.amount' | translate }}"
          [translateFieldKey]="'table.amount'"
          propertyName="totalPrice"
          [dataType]="dataType.NUMBER"
          [defaultValue]="activeFilters | filterFor : 'totalPrice'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.totalPrice }}</mat-cell>
    </ng-container>

    <!-- Adherence -->
    <ng-container matColumnDef="adherence">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "table.adherence" | translate }}
        <app-item-filter
          fieldName="{{ 'table.adherence' | translate }}"
          [translateFieldKey]="'table.adherence'"
          propertyName="adherence"
          [dataType]="dataType.NUMBER"
          [defaultValue]="activeFilters | filterFor : 'adherence'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.adherence * 100 }}%</mat-cell>
    </ng-container>

    <!-- Status -->
    <ng-container matColumnDef="status">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header>
        {{ "table.status" | translate }}
        <app-item-filter
          fieldName="{{ 'table.status' | translate }}"
          [translateFieldKey]="'table.status'"
          propertyName="billingStatus"
          translatePrefix="billing.status"
          [dataType]="dataType.CHOICE"
          [defaultValue]="activeFilters | filterFor : 'billingStatus'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span
          class="status-box"
          [ngClass]="billingStatusClasses[row.status]"
          [matMenuTriggerFor]="(row.status | availableStatusTransitions).length > 0 ? statusMenu : undefined"
        >
          {{ "billing.status." + row.status | translate
          }}<ng-container *ngIf="(row.status | availableStatusTransitions).length > 0">
            &nbsp;<mat-icon class="fa-icon" fontSet="fas" fontIcon="fa-caret-down"></mat-icon
          ></ng-container>
        </span>

        <mat-menu #statusMenu="matMenu">
          <button mat-menu-item *ngFor="let status of row.status | availableStatusTransitions" (click)="onUpdateStatus(row, status)">
            {{ "billing.status." + status | translate }}
          </button>
        </mat-menu>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="careplan">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="officialCareplan">
        {{ "table.careplan" | translate }}
        <app-item-filter
          fieldName="{{ 'table.careplan' | translate }}"
          [translateFieldKey]="'table.careplan'"
          propertyName="officialCareplan"
          [dataType]="dataType.TEXT"
          [defaultValue]="activeFilters | filterFor : 'officialCareplan'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.officialCareplan }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="prescriptionStart">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="prescriptionStart">
        {{ "table.prescriptionStart" | translate }}
        <app-item-filter
          fieldName="{{ 'table.prescriptionStart' | translate }}"
          [translateFieldKey]="'table.prescriptionStart'"
          propertyName="prescriptionStart"
          [dataType]="dataType.DATE"
          [defaultValue]="activeFilters | filterFor : 'prescriptionStart'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.prescription.startDate | safeDate }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="prescriptionDuration">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="prescriptionDuration">
        {{ "table.prescriptionDuration" | translate }}
        <app-item-filter
          fieldName="{{ 'table.prescriptionDuration' | translate }}"
          [translateFieldKey]="'table.prescriptionDuration'"
          propertyName="prescriptionDuration"
          [dataType]="dataType.NUMBER"
          [defaultValue]="activeFilters | filterFor : 'prescriptionDuration'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{
        (row.prescription.duration.durationUnit | i18nPeriodUnitKey)
          ? row.prescription.duration.duration +
            " " +
            ("periodUnit." + (row.prescription.duration.durationUnit | i18nPeriodUnitKey) + ".singPlural" | translate)
          : row.prescription.duration.duration
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="prescriptionStatus">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="prescriptionStatus">
        {{ "table.prescriptionStatus" | translate }}
        <app-item-filter
          fieldName="{{ 'table.prescriptionStatus' | translate }}"
          [translateFieldKey]="'table.prescriptionStatus'"
          [translatePrefix]="'prescription.status'"
          propertyName="prescriptionStatus"
          [dataType]="dataType.CHOICE"
          [defaultValue]="activeFilters | filterFor : 'prescriptionStatus'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ "prescription.status." + row.prescription.status | translate }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="billingCycle">
      <mat-header-cell cdkDrag *matHeaderCellDef mat-sort-header="billingCycle">
        {{ "table.billingCycle" | translate }}
        <app-item-filter
          fieldName="{{ 'table.billingCycle' | translate }}"
          [translateFieldKey]="'table.billingCycle'"
          propertyName="billingCycle"
          [dataType]="dataType.NUMBER"
          [defaultValue]="activeFilters | filterFor : 'billingCycle'"
          (applyFilter)="applyFilter($event)"
        >
        </app-item-filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{
        (row.prescription.pricingPeriodicity.periodUnit | i18nPeriodUnitKey)
          ? row.prescription.pricingPeriodicity.frequency +
            " " +
            ("periodUnit." + (row.prescription.pricingPeriodicity.periodUnit | i18nPeriodUnitKey) + ".singPlural" | translate)
          : row.prescription.pricingPeriodicity.frequency
      }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="primoPrescriptionStart">
      <mat-header-cell cdkDrag *matHeaderCellDef>
        {{ "table.primoPrescriptionStart" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.prescription.primoPrescriptionStart | safeDate }}</mat-cell>
    </ng-container>

    <!-- internal id Column -->
    <ng-container matColumnDef="internalId">
      <mat-header-cell cdkDrag *matHeaderCellDef>
        {{ "table.internalId" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.internalId }}</mat-cell>
    </ng-container>

    <!-- pseudoname Column -->
    <ng-container matColumnDef="pseudoname">
      <mat-header-cell cdkDrag *matHeaderCellDef>
        {{ "forms.pseudoname" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.pseudoname }}</mat-cell>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>{{ "table.action" | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button mat-icon-button>
          <mat-icon class="fa-icon" fontSet="fas" fontIcon="fa-paper-plane" (click)="onSend(row)"></mat-icon>
        </button>
        <button mat-icon-button *ngIf="('dashboard/exportChargeItem' | isAuthorized | async) === true">
          <mat-icon class="fa-icon" fontSet="fas" fontIcon="fa-download" (click)="download(row)"></mat-icon>
        </button>
        <button mat-icon-button>
          <mat-icon class="fa-icon" fontSet="fas" fontIcon="fa-comments" (click)="showNotes(row)"></mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <!-- Header & Rows -->
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
